import { API } from '@/App';

// Cookie-authenticated JSON call; throws Error(detail) on non-2xx.
export async function jsonApi(path, method = 'GET', body) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(typeof data.detail === 'string' ? data.detail : 'Request failed');
    err.status = res.status;
    throw err;
  }
  return data;
}
